import styles from "./site_list.module.css";

export default function SiteList(props) {
  const { sites_no_enrollment } = props;

  return (
    <div className={styles.wrapper}>
      <div className={styles.title}>Sites Without Enrollment</div>

      {sites_no_enrollment?.length ? (
        <div className={styles.site_list_wrapper}>
          <div className={styles.site_list}>
            <div>
              {sites_no_enrollment.map((s) => (
                <div className={styles.site_row}>•{s}</div>
              ))}
            </div>{" "}
          </div>
        </div>
      ) : (
        <div>No Sites</div>
      )}
    </div>
  );
}
